import { render, staticRenderFns } from "./sales-order-v3.vue?vue&type=template&id=9a4c6aca&"
import script from "./sales-order-v3.vue?vue&type=script&lang=js&"
export * from "./sales-order-v3.vue?vue&type=script&lang=js&"
import style0 from "./sales-order-v3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports